import {SxProps, Theme} from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import logoImg from 'shared/assets/img/logo.png';

type LogoProps = {
  sx?: SxProps<Theme> | undefined;
};

export const Logo: FC<LogoProps> = props => {

  return (
      <Link to="/">
          <img src={logoImg} alt="Bricks"/>
      </Link>
  );
};
